import { render, staticRenderFns } from "./EditContactsDialog.vue?vue&type=template&id=169eb8fc"
import script from "./EditContactsDialog.vue?vue&type=script&lang=js"
export * from "./EditContactsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports